import { createApp } from 'vue'
import CategoryPicker from './CategoryPicker'

const el = '.kb-component--category-picker'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((CategoryPickerDOM) => {
            const categories = CategoryPickerDOM.dataset.categories
                ? JSON.parse(CategoryPickerDOM.dataset.categories)
                : []
            const component = createApp(CategoryPicker, { categories }).use(
                Store
            )
            component.mount(CategoryPickerDOM)
        })
    }
}
